import type { RouteObject } from 'react-router-dom';
import AboutPage from '@/pages/about/page';
import CategoryPage from '@/pages/category/page';
import ArticlePage from '@/pages/article/page';
import Home from '@/pages/home/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/category/:slug',
    element: <CategoryPage />,
  },
  {
    path: '/article/:slug',
    element: <ArticlePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;